import { render, staticRenderFns } from "./CardMcDetail.vue?vue&type=template&id=49f03abc&scoped=true&"
import script from "./CardMcDetail.vue?vue&type=script&lang=js&"
export * from "./CardMcDetail.vue?vue&type=script&lang=js&"
import style0 from "./CardMcDetail.vue?vue&type=style&index=0&id=49f03abc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f03abc",
  null
  
)

export default component.exports